module.exports = __webpack_public_path__ + "img/bigBg.e96edd0b.png";